<template>
  <transition name="slide-fade">
    <div class>
      <router-view></router-view>
      <div class="row scenario shadow rounded bg-white mx-2 pt-4 d-flex">
        <div class="col-12 align-self-start d-flex justify-content-between top-bar">
          <div class="flex-start align-self-start">
            <h4 class="font-weight-bold" style="margin-bottom:0.1rem">
              <router-link :to="{ name: 'scenario-view', params: { uuidId: uuidId } }">{{ name }}</router-link>
            </h4>

            <div class="scenario-stats my-2 d-flex flex-column">
              <div class="d-flex align-items-center">
                <i class="material-icons text-secondary">person</i>
                <em>Contributed By:</em>

                <router-link :to="{ name: 'view-user', params: { id: userUuId } }">
                  <span class="element-label">{{ contributedBy }}</span>
                </router-link>
              </div>

              <div class="d-flex align-items-center">
                <i class="material-icons text-secondary">star</i>
                <em>Favourited:</em>
                <span class="element-label">
                  <em>{{ numberFavourites }}</em>
                </span>
              </div>

              <div class="d-flex align-items-center">
                <i class="material-icons text-secondary">save_alt</i>
                <em>Downloads:</em>
                <span class="element-label">
                  <em>{{ numDownloads }}</em>
                </span>
              </div>
            </div>
          </div>
          <div class="text-right sm-align-self-end">
            <ScenarioActions :uuidId="uuidId" :isFavouritedByUser="isFavouritedByUser"></ScenarioActions>
          </div>
        </div>

        <div
          class="col-12 align-self-center d-flex sm-justify-content-between"
          style="margin-top:1rem"
        >
          <div class="d-flex justify-content-center image-wrapper my-1 align-self-center mr-3">
            <router-link :to="{ name: 'scenario-view', params: { uuidId: uuidId } }">
              <img :src="deviceThumb" title style />
            </router-link>
          </div>

          <div class="desc-wrapper align-self-start d-flex flex-column mr-3">
            <p class="d-none d-md-block mb-0 mt-4 w-65">{{ description }}</p>
            <ul class="d-none d-md-flex scenario-tags align-self- flex-wrap px-0 my-3 w-100">
              <li
                v-bind:key="tag.id"
                v-for="tag in tags"
                v-bind:class="{ selected: tag.isCurrentlySelected }"
              >{{ tag.title }}</li>
            </ul>
          </div>
        </div>

        <div class="col-12 d-block d-none d">
          <ul
            class="d-flex contribution-elements align-self-top mt-3 list-unstyled text-right d-flex justify-content-between w-10"
          ></ul>
        </div>
        <div class="d-none d-sm-block col-12 align-self-end mt-3 bg-light">
          <ScenarioElements
            bind:fileSize="fileSize"
            :language="language"
            :durationInSeconds="durationInSeconds"
            :numChecklistItems="numChecklistItems"
            :numEvents="numEvents"
            :hasMedia="hasMedia"
            :hasSounds="hasSounds"
            :hasLabs="hasLabs"
          ></ScenarioElements>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import ScenarioActions from "../components/ScenarioActions";
import ScenarioElements from "../components/ScenarioElements";
import ScenarioHelper from "../utils/scenario.helper";
import scenarioHelper from "../utils/scenario.helper";

export default {
  name: "Scenario",
  data: function() {
    return {
      deviceThumb: require("../assets/device/" +
        ScenarioHelper.getFilenameForDeviceThumb(this.deviceId))
    };
  },

  methods: {
    updateFavouriteScenariosList() {
      this.$parent.updateFavouriteScenariosList();
    },

    shouldTagBeSelected() {
      if (this.$props.tags) {
        this.$props.tags.forEach(scenarioTag => {
          if (this.$props.currentlySelectedTags) {
            this.$props.currentlySelectedTags.forEach(selectedTag => {
              if (scenarioTag.id == selectedTag) {
                scenarioTag["isCurrentlySelected"] = true;
              }
            });
          }
        });
      }
    }
  },

  components: {
    ScenarioActions,
    ScenarioElements
  },

  props: {
    uuidId: String,
    userId: Number,
    name: String,
    description: String,
    fileSize: String,
    language: String,
    deviceId: Number,
    numEvents: Number,
    numChecklistItems: Number,
    hasMedia: Boolean,
    _hasImages: Boolean,
    get hasImages() {
      return this._hasImages;
    },
    set hasImages(value) {
      this._hasImages = value;
    },
    hasSounds: Boolean,
    hasLabs: Boolean,
    objectUrl: String,
    durationInSeconds: Number,
    numDownloads: Number,
    contributedBy: String,
    isFavouritedByUser: Boolean,
    numberFavourites: Number,
    tags: Array,
    patientAge: Number,
    patientCondition: Number,
    currentlySelectedTags: Array,
    userUuId: String
  },

  beforeMount() {
    this.shouldTagBeSelected();
    //this.deviceThumb = scenarioHelper.getFilenameForDeviceThumb(this.deviceId);
  },

  beforeUpdate() {
    this.shouldTagBeSelected();
  }
};
</script>

<style>
.scenario {
  margin-bottom: 30px;
  min-height: 400px;
  overflow: hidden;
}
.scenario-contributed-by {
  text-align: right;
}
.scenario-elements {
  padding: 0;
  margin: 0;
}
.scenario-elements li {
  display: inline-block;
  height: 50px;
}
.scenario-tags li {
  margin-right: 10px;
  margin-top: 5px;
  margin-bottom: 5px;
}

.scenario-elements li i {
  margin-right: 5px;
}

.scenario-tags li {
  display: inline-block;
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
  border-radius: 7px;
  padding: 4px;
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}
.contribution-element {
  display: flex;
}

.contribution-element .element-label {
  margin-right: 5px;
  white-space: nowrap;
}

.scenario-stats i {
  margin-right: 5px;
}

.scenario-stats em {
  color: #6c757d;
  margin-right: 10px;
  font-size: 14px;
}

li.selected {
  background-color: #CB2E37;
  border-color: #CB2E37;
}

li .tiny-span {
  font-size: 12px;
  color: #CB2E37;
}
@media (max-width: 575.98px) {
  .top-bar {
    flex-direction: column;
  }
  .scenario h3 {
    display: block;
    width: 100%;
    text-align: left !important;
  }
  .sccenario #actions {
    width: 100%;
  }
  .image-wrapper {
    width: 100%;
  }

  .image-wrapper {
    width: 100%;
  }
  .image-wrapper img {
    max-width: 500px !important;
  }
}
</style>
